import React from 'react';
import _ from 'lodash';

function CheckboxGroup(props) {
  function isCheckbox(element) {
    const displayName = _.get(element, 'type.displayName', '');
    return displayName.includes('Checkbox');
  }

  function injectRadioButtonProps(elements, n = 0) {
    return React.Children.map(elements, element => {
      if (isCheckbox(element) && n >= 3) {
        throw new Error('CheckboxGroup - Nesting is limited for 3 levels.');
      }

      if (isCheckbox(element)) {
        return React.cloneElement(element, {
          className: element.props.className + ' ' + props.itemClassName,
        });
      } else if (element && element.props) {
        return React.cloneElement(element, {
          children: injectRadioButtonProps(element.props.children, n + 1),
        });
      }
    });
  }

  return <div className={props.className}>{injectRadioButtonProps(props.children)}</div>;
}

export default CheckboxGroup;
